import Service from 'src/setup/network';

const onDragEnd = (
  result: any,
  orderData: any,
  setOrderData: any,
  categoryData: any,
  api: any,
  pageSize?: any,
  pageIndex?: any
): void => {
  if (!result.destination) {
    return;
  }

  const offset = pageSize * pageIndex;

  const reorderedData =
    orderData.length > 0 ? [...orderData] : [...categoryData];
  const movedItem = reorderedData.splice(result.source.index + offset, 1)[0];
  reorderedData.splice(result.destination.index + offset, 0, movedItem);

  setOrderData(reorderedData);
  if (api) {
    const payload = {
      id: movedItem?.categoryInfo?.id || movedItem?.id,
      newOrder: result.destination.index + 1 + offset,
    };

    Service.post(api, payload)
      .then(() => {
        setOrderData(reorderedData);
      })
      .catch((error) => {
        console.error('Error updating category order:', error);
        setOrderData(orderData);
      });
  }
};

export { onDragEnd };
